const minHeight = typeof window !== 'undefined' && window.innerHeight
const minWidth = typeof window !== 'undefined' && window.innerWidth

const styles = theme => ({
  root: {
    flexGrow: 1,
    height: '100vh',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'center',
  },
  textField: {
    marginRight: theme.spacing.unit * 2,
    display: 'block',
    minWidth: minWidth / 2
  },
  block: {
    display: 'block'
  },
  modal: {
    width: '25%',
    maxWidth: minWidth / 1.5
  },
  form: {
    maxHeight: minHeight / 2,
    overflowY: 'scroll'
  },
  button: {
    marginLeft: theme.spacing.unit * 2,
    backgroundColor:  theme.palette.accent,
    color:'white',
    minWidth:40,
    },
  submit: {
    backgroundColor:  theme.palette.accent,
    color:'white',
    '&:hover': {
      backgroundColor: '#fd5622',
    },
    width:'100%'
  },
  close: {
    padding:0,
    minWidth:40,
  },
  list: {
    maxHeight: 300,
    overflowY: 'auto'
  },
  listItem: {
    // '&.focus': {
    //   backgroundColor: theme.palette.grey[400]
    // }
  },
  selectedListItem: {
    backgroundColor: theme.palette.grey[400]
  },
  error: {
    background: theme.palette.secondary.main,
    color: theme.palette.common.white,
    textAlign: 'center'
  },
  title:{
    textTransform: 'uppercase',
    color: '#1C408C!important',
    fontSize: '1.2rem!important',
    fontWeight: '600!important'
  },
  subTitle: {
    fontWeight: '400!important',
    '& b':{
      color: '#1C408C!important',
      textTransform: 'none',
    }
  },
  footer:{
    marginTop: '20px'
  }
})

export default styles
